import { DIALOG_CONSTANTS } from '../actionTypes'

export const dialogAction = {
	openDialog,
	closeDialog,
}

// TERMS & CONDITIONS
function openDialog(type) {
	return (dispatch) => {
		dispatch(open(type))
	}
	function open(type) {
		return { type: DIALOG_CONSTANTS.TERMS_OPEN, response: type }
	}
}

function closeDialog() {
	return (dispatch) => {
		dispatch(close())
	}

	function close() {
		return { type: DIALOG_CONSTANTS.TERMS_CLOSE }
	}
}
